import React, {useEffect, useMemo, useState} from 'react';
import { ServerFailed } from '../errors/serverFailed'
import { Theme } from '@material-ui/core/styles';

import {  Typography, Grid, CardContent, Card, makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import { BuilderAssetService } from '../../services/BuilderAssetService';
import { BuilderAsset } from '../../entities/BuilderAsset';
import { SermonTemplateService } from '../../services/SermonTemplateService';

import {SermonTemplate} from '../../entities/SermonTemplate';
import classNames from 'classnames';
import {Search} from '../../utilities/PremiumTemplateSearch'
import SearchIcon from '@material-ui/icons/Search';
import { useIsMobile } from '../../components/Mui3WidthProvider';
import { useQueryParams } from '../../components/useQueryParams';
import { GridGrow } from '../../components/GridGrow';
import { HorizontalCentered } from '../../components/HorizontalCentered';
import { VerticalCenter } from '../../components/VerticalCenter';
import { useLibrarySearch } from './LibraryPage';
import { AddFromSermonTemplateDialog } from './Views/Components/Dialogs/AddFromSermonTemplateDialog';
import { AddFromCustomTemplateDialog } from './Views/Components/Dialogs/AddFromCustomTemplateDialog';
import { PageTitle } from '../../components/PageTitle';

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        opacity: 1,
        transition: 'all 0.3s ease 0s',
        MozTransition: 'all 0.3s ease 0s',
        WebkitTransition: 'all 0.3s ease 0s',
        height: "100%",
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.9,
            transition: 'all 0.3s ease 0s',
            MozTransition: 'all 0.3s ease 0s',
            WebkitTransition: 'all 0.3s ease 0s'
        }
    },
    focusedCard: {
        boxShadow: '0 0 5px 5px rgb(66, 133, 244, .7)'
    },
}));


const searchCustomTemplates = (searchTerm: string, templates: BuilderAsset[]):BuilderAsset[] => {
	var regex = new RegExp(searchTerm, "i");
	return templates.filter((template) => {
        if(template.isTemplate){
            if (regex.test(template.name)) {
                return template;
            } else if (regex.test(template.text)) {
                return template;
            } else if (regex.test(template.templateDescription)) {
                return template;
            }
        } 
        return null;
    });
};

export function SermonTemplates(){
    const classes = useStyles();
    const searchContext = useLibrarySearch();
    const { searchValue } = searchContext;
    const [customTemplates, setCustomTemplates] = useState<BuilderAsset[]>([])
    const [premiumTemplates, setPremiumTemplates] = useState<SermonTemplate[]>([])
    const [selectedPremiumTemplateId, setSelectedPremiumTemplateId] = useState<number>()
    const [selectedCustomTemplateId, setSelectedCustomTemplateId] = useState('')
    
    const [showCustomTemplateDialog, setShowCustomTemplateDialog ] = useState<boolean>(false)
    const [showPremiumTemplateDialog, setShowPremiumTemplateDialog ] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [serverFailed, setServerFailed] = useState<boolean>(false);
    
    const displayPremiumTemplates = useMemo(() => Search(searchValue, [...premiumTemplates]), [searchValue, premiumTemplates])
    const displayCustomTemplates = useMemo(() => searchCustomTemplates(searchValue, [...customTemplates]), [searchValue, customTemplates])
    const SelectedCustomTempalate = useMemo(() => customTemplates.find(t => t.id === selectedCustomTemplateId), [selectedCustomTemplateId, customTemplates])
    const SelectedPremiumTemplate = useMemo(() => premiumTemplates.find(t => t.id === selectedPremiumTemplateId), [selectedPremiumTemplateId, premiumTemplates])
    
    const isMobile = useIsMobile();
    const query = useQueryParams();

    useEffect(() => {
        async function loadTemplates(){
            setServerFailed(false)
            setIsLoading(true);
            const responses = await Promise.all([
                BuilderAssetService.getTemplates(),
                SermonTemplateService.getAllEnabled()
            ]);
            setIsLoading(false);
            
            const [customTemplateResponse, sermonTemplatesResponse] = responses;
            
            if(customTemplateResponse.error || sermonTemplatesResponse.error)
                return setServerFailed(true)
            
            const focusedId = query.get("templateId");

            if(customTemplateResponse.success)
                setCustomTemplates(customTemplateResponse.data)

            if(sermonTemplatesResponse.success){
                setPremiumTemplates(sermonTemplatesResponse.data)
                setSelectedPremiumTemplateId(focusedId && !isNaN(+focusedId) ? +focusedId : -1)
            }
        }
        loadTemplates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const openCustomTemplateModel = (templateId:string) => {
        setSelectedCustomTemplateId(templateId);
        setShowCustomTemplateDialog(true);
    }
    
    const closeCustomTemplateModel = () => {
        setSelectedCustomTemplateId('');
        setShowCustomTemplateDialog(false);
    }

    const openPremiumTemplateModel = (templateId:number) => {
        setSelectedPremiumTemplateId(templateId);
        setShowPremiumTemplateDialog(true);
    }

    const closePremiumTemplateModel = () => {
        setSelectedPremiumTemplateId(undefined);
        setShowPremiumTemplateDialog(false);
    }

    return (
        <div style={{height: "100%"}}>
            <PageTitle title="Sermon Maker - Sermon Templates" />
            { !isMobile &&
                <Grid container style={{height: 45, borderBottom: "1px solid rgb(225, 225, 225)"}}>
                    <Grid container item md={8} lg={9} alignItems="center">
                            <Grid item>
                                <Typography style={{ color: "#5f6368", fontSize: "18px", fontWeight: 500, fontFamily: "Roboto, Helvetica"}}>
                                    Sermon Templates
                                </Typography>
                            </Grid>
                        <GridGrow />
                    </Grid>
                </Grid>
            }
            <Grid container style={{height: isMobile ? "100%" : "calc(100% - 45px)"}}>
            {serverFailed
                ?
                    <Grid container style={{height: "100%"}}>
                        <VerticalCenter>
                            <HorizontalCentered>
                                <ServerFailed errorMessage="We're sorry, but we're having trouble loading templates." />
                            </HorizontalCentered>
                        </VerticalCenter>
                    </Grid>
                : 
                <Grid item xs={12} style={{height: "100%", overflowY: "auto", overflowX: "hidden"}}>
                { isLoading
                ?
                    <div style={{ textAlign: 'center' }}>
                        <CircularProgress style={{ marginTop: "50px" }} />
                        <br />
                        <Typography variant="body1" color="textSecondary" style={{ textAlign: 'center' }}>
                            {searchValue ? "Searching" : "Loading"} Sermon Templates...
                        </Typography>
                    </div>
                : displayCustomTemplates.length === 0 && displayPremiumTemplates.length === 0
                ?
                    <VerticalCenter>
                        <HorizontalCentered>
                            <HorizontalCentered>
                                <SearchIcon style={{ width: "150px", height: "150px", color: "#CCC"}}/>
                            </HorizontalCentered>
                            <Typography 
                                style={{ 
                                    fontFamily: "Roboto, Helvetica", fontSize: "12px", marginTop: "12px", color: "#5f6368"
                            }}
                            >No matches found for {searchContext.searchValue}. Please try again.</Typography>
                        </HorizontalCentered>
                    </VerticalCenter>
                :
                    <Grid container spacing={3} style={{ padding: '20px' }}>
                        {displayCustomTemplates.map(customTemplate => {
                            return (
                                <Grid item key={customTemplate.id} xs={12} sm={3}>
                                    <Card className={classes.card} onClick={() => openCustomTemplateModel(customTemplate.id)} >
                                    <img alt="Sermon Template" width="100%" src="//i.cdn-sc.com/Logos/SermonMaker_384x216.jpg"/>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                {customTemplate.name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                {customTemplate.templateDescription}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        })}
                        {displayPremiumTemplates.map(premiumTemplate => {
                            return (
                                <Grid item key={premiumTemplate.id} xs={12} sm={3}>
                                    <Card 
                                        id={premiumTemplate.id.toString()} 
                                        className={classNames(classes.card, premiumTemplate.id === selectedPremiumTemplateId ? classes.focusedCard : undefined)} 
                                        onClick={() => openPremiumTemplateModel(premiumTemplate.id)} 
                                        >
                                        <img alt="Sermon Template" width="100%" src={premiumTemplate.thumbnailUrl ?? "//i.cdn-sc.com/Logos/SermonMaker_384x216.jpg"} onError={(e) => e.currentTarget.setAttribute('src', "//i.cdn-sc.com/Logos/SermonMaker_384x216.jpg")}/>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                {premiumTemplate.name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                {premiumTemplate.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                        )}
                    </Grid>
                }
                </Grid>
            }
            </Grid>
            {SelectedCustomTempalate && 
                <AddFromCustomTemplateDialog 
                    open={showCustomTemplateDialog}
                    customTemplate={SelectedCustomTempalate}
                    onClose={() => closeCustomTemplateModel()}
                />
            }
            {SelectedPremiumTemplate &&
                <AddFromSermonTemplateDialog  
                    open={showPremiumTemplateDialog}
                    sermonTemplate={SelectedPremiumTemplate}
                    onClose={() => closePremiumTemplateModel()}
                />
            }
        </div>
    );
}